import { render, staticRenderFns } from "./AddBuyer.vue?vue&type=template&id=23fa104e&scoped=true&"
import script from "./AddBuyer.vue?vue&type=script&lang=js&"
export * from "./AddBuyer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23fa104e",
  null
  
)

export default component.exports